import releaseConfig from 'releaseConfig';

export const getApiUrl = () => {
  return releaseConfig.apiUrl.startsWith('#{')
    ? import.meta.env.VITE_API_URL || 'https://localhost:5001'
    : releaseConfig.apiUrl;
};

export const getAmApiUrl = () => {
  return releaseConfig.amApiUrl.startsWith('#{')
    ? import.meta.env.VITE_AM_API_URL || 'https://localhost:8081'
    : releaseConfig.amApiUrl;
};

export const getAiApiUrl = () => {
  return releaseConfig.aiApiUrl.startsWith('#{')
    ? import.meta.env.VITE_AI_API_URL || 'https://dev.api.ai.nps.today'
    : releaseConfig.aiApiUrl;
};

const isAbsoluteHttpsUrl = (value: unknown): value is string => {
  if (typeof value !== 'string') {
    return false;
  }
  try {
    return new URL(value).protocol === 'https:';
  } catch {
    return false;
  }
};

export const getDwApiUrl = (): string | undefined => {
  const { dwApiUrl } = releaseConfig;
  if (isAbsoluteHttpsUrl(dwApiUrl)) {
    return dwApiUrl;
  }
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_DW_API_URL || 'https://localhost:7063';
  }
  return undefined;
};

export const isDwApiConfigured = () => getDwApiUrl() !== undefined;

export const getSurveyUrl = () => {
  return releaseConfig.surveyUrl.startsWith('#{')
    ? import.meta.env.VITE_SURVEY_URL || 'https://dev.r.nps.today'
    : releaseConfig.surveyUrl;
};

export const getSmsUrl = () => {
  return releaseConfig.smsUrl.startsWith('#{')
    ? import.meta.env.VITE_SMS_URL || 'https://dev.sms.nps.today'
    : releaseConfig.smsUrl;
};

export const getFeedbackAppUrl = () => {
  return releaseConfig.feedbackAppUrl.startsWith('#{')
    ? import.meta.env.VITE_FEEDBACK_APP_URL || 'https://localhost:3001'
    : releaseConfig.feedbackAppUrl;
};

export const getMicrosoftLoginRedirectUri = () => {
  return releaseConfig.redirectUri.startsWith('#{')
    ? import.meta.env.VITE_REDIRECT_URI || 'http://localhost:3000/login/microsoft'
    : releaseConfig.redirectUri;
};
